/** Server multipart limit — keep in sync with MediaController upload/video attributes. */
export const VIDEO_SERVER_UPLOAD_LIMIT_MB = 80;

/** Target size after browser optimization (margin for multipart encoding overhead). */
export const VIDEO_UPLOAD_TARGET_MB = 75;

/** Largest source video the browser will accept before client-side optimization. */
export const VIDEO_MAX_SOURCE_MB = 500;

export const VIDEO_COMPRESSION_THRESHOLD_MB = 10;
